import React, { useState, useEffect } from 'react';
import { Link } from 'react-scroll';
import '../assets/styles/Navbar.css';
import logoLight from '../assets/images/logo_light.svg';
import logoDark from '../assets/images/logo_dark.svg';

const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const offset = window.scrollY;
      if (offset > 50) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const toggleMobileMenu = () => {
    setMobileMenuOpen(!mobileMenuOpen);
  };

  const closeMobileMenu = () => {
    setMobileMenuOpen(false);
  };

  return (
    <nav className={scrolled ? 'navbar scrolled' : 'navbar'}>
      <div className="container navbar-container">
        <div className="navbar-logo">
          <Link to="hero" smooth={true} duration={500} onClick={closeMobileMenu}>
            <img src={scrolled ? logoDark : logoLight} alt="Fertro" />
          </Link>
        </div>

        <div className="mobile-menu-toggle" onClick={toggleMobileMenu}>
          <div className={mobileMenuOpen ? "hamburger active" : "hamburger"}>
            <span></span>
            <span></span>
            <span></span>
          </div>
        </div>

        <ul className={mobileMenuOpen ? "navbar-menu active" : "navbar-menu"}>
          <li className="navbar-item">
            <Link 
              to="services" 
              smooth={true} 
              duration={500} 
              spy={true} 
              activeClass="active"
              onClick={closeMobileMenu}
            >
              Services
            </Link>
          </li>
          <li className="navbar-item">
            <Link 
              to="about" 
              smooth={true} 
              duration={500} 
              spy={true} 
              activeClass="active"
              onClick={closeMobileMenu}
            >
              About
            </Link>
          </li>

          <li className="navbar-item">
            <a
              href="mailto:info@fertro.com"
              className="btn navbar-btn"
              onClick={closeMobileMenu}
            >
              Contact Us
            </a>
          </li>
        </ul>
      </div>
    </nav>
  );
};

export default Navbar;
